<script lang="ts">
  import { Home } from 'lucide-svelte';
  
  function handleClick(event: MouseEvent) {
    event.preventDefault();
    
    window.location.href = '/';
    
    window.scrollTo(0, 0);
  }
</script>

<a href="/" class="back-home glass" aria-label="Back to home" on:click={handleClick}>
  <Home size={18} />
  <span>Home</span>
</a>

<style>
  .back-home {
    position: fixed;
    top: var(--spacing-lg);
    right: var(--spacing-lg);
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
    border-radius: var(--border-radius-small);
    border: 1px solid var(--glass-border);
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    color: var(--text-primary);
    text-decoration: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 99;
  }

  .back-home:hover {
    background: var(--accent-orange);
    border-color: var(--accent-orange);
    transform: translateY(-2px);
    box-shadow: 0 10px 30px var(--accent-orange-glow);
  }
</style> 